// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  box-sizing: border-box;
}

.signoutBtn {
  width: 120px;
  border-radius: 5px;
  position: absolute;
  right: 1%;
  top: 1.5%;
  /* background-color: #c2fbd7; */
  background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);
  border-radius: 25px;
  /* box-shadow: rgba(44, 187, 99, .2) 0 -25px 18px -14px inset, rgba(44, 187, 99, .15) 0 1px 2px, rgba(44, 187, 99, .15) 0 2px 4px, rgba(44, 187, 99, .15) 0 4px 8px, rgba(44, 187, 99, .15) 0 8px 16px, rgba(44, 187, 99, .15) 0 16px 32px;
  box-shadow: rgba(44, 187, 99, .35) 0 -25px 18px -14px inset, rgba(44, 187, 99, .25) 0 1px 2px, rgba(44, 187, 99, .25) 0 2px 4px, rgba(44, 187, 99, .25) 0 4px 8px, rgba(44, 187, 99, .25) 0 8px 16px, rgba(44, 187, 99, .25) 0 16px 32px; */
  color: rgb(255, 255, 255);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
  padding: 7px 20px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 14px;
  font-weight: 600;
  user-select: none;
  -webkit-user-select: none;
  z-index: 15;
}

.menuBtnDash {
  position: absolute;
  right: 1%;
  top: 2.0%;
  z-index: 15;
}

/* .signoutBtn:hover {
  box-shadow: rgba(44, 187, 99, .35) 0 -25px 18px -14px inset, rgba(44, 187, 99, .25) 0 1px 2px, rgba(44, 187, 99, .25) 0 2px 4px, rgba(44, 187, 99, .25) 0 4px 8px, rgba(44, 187, 99, .25) 0 8px 16px, rgba(44, 187, 99, .25) 0 16px 32px;
} */

.homeDiv {
  width: 100%;
  margin: auto;
  /* background-color: #151e3d; */
  /* background-image: url("../images/bg.png"); */

}

.HomeLeftDiv {
  width: 80%;
  margin: auto;
  display: inline-block;
  height: 100%;
  padding: 2%;
  /* background-image: url("../images/bg.png"); */
  background-color: white
}

.HomeRightDiv {
  display: inline-block;
  height: 100%;
  width: 50%;
  background-color: #c2fbd7;
  height: 100vh;
  position: fixed;
  right: 0%;
  top: 0;
  z-index: -1;
}

/* .formDetails{
    box-shadow: rgba(71, 169, 109, 0.25) 0px 50px 100px -20px, rgba(28, 218, 148, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    height: 100%;
    padding: 2%; */
/* background-color: white; */
/* background-color: #f6f6f6; */
/* margin: auto;
    margin-left: 2%;
  } */
.formTitle {
  text-align: center;
  color: #174f5d;
  color: #35b276;
  color: #151e3d;
  color: #174f5d;
  font-weight: 600;
  margin-top: 3%;
  margin-bottom:2% ;
  font-family: 'Open Sans', sans-serif;

}

.formSubText {
  color: #808080;
  text-align: center;
  width: 76%;
  margin: auto;
}

.hrLine {
  color: #35b276;
  height: 4px;
  background-color: #35b276;
  width: 80%;
  margin: auto;
  margin-top: 3%;
  margin-bottom: 10%;
}`, "",{"version":3,"sources":["webpack://./src/styleSheet/Home.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,+BAA+B;EAC/B,kEAAkE;EAClE,mBAAmB;EACnB;6OAC2O;EAC3O,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,8EAA8E;EAC9E,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;AACb;;AAEA;;GAEG;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,+CAA+C;;AAEjD;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,+CAA+C;EAC/C;AACF;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,SAAS;EACT,MAAM;EACN,WAAW;AACb;;AAEA;;;;kBAIkB;AAClB,6BAA6B;AAC7B,+BAA+B;AAC/B;;KAEK;AACL;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oCAAoC;;AAEtC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB","sourcesContent":["body {\n  box-sizing: border-box;\n}\n\n.signoutBtn {\n  width: 120px;\n  border-radius: 5px;\n  position: absolute;\n  right: 1%;\n  top: 1.5%;\n  /* background-color: #c2fbd7; */\n  background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);\n  border-radius: 25px;\n  /* box-shadow: rgba(44, 187, 99, .2) 0 -25px 18px -14px inset, rgba(44, 187, 99, .15) 0 1px 2px, rgba(44, 187, 99, .15) 0 2px 4px, rgba(44, 187, 99, .15) 0 4px 8px, rgba(44, 187, 99, .15) 0 8px 16px, rgba(44, 187, 99, .15) 0 16px 32px;\n  box-shadow: rgba(44, 187, 99, .35) 0 -25px 18px -14px inset, rgba(44, 187, 99, .25) 0 1px 2px, rgba(44, 187, 99, .25) 0 2px 4px, rgba(44, 187, 99, .25) 0 4px 8px, rgba(44, 187, 99, .25) 0 8px 16px, rgba(44, 187, 99, .25) 0 16px 32px; */\n  color: rgb(255, 255, 255);\n  cursor: pointer;\n  display: inline-block;\n  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;\n  padding: 7px 20px;\n  text-align: center;\n  text-decoration: none;\n  transition: all 250ms;\n  border: 0;\n  font-size: 14px;\n  font-weight: 600;\n  user-select: none;\n  -webkit-user-select: none;\n  z-index: 15;\n}\n\n.menuBtnDash {\n  position: absolute;\n  right: 1%;\n  top: 2.0%;\n  z-index: 15;\n}\n\n/* .signoutBtn:hover {\n  box-shadow: rgba(44, 187, 99, .35) 0 -25px 18px -14px inset, rgba(44, 187, 99, .25) 0 1px 2px, rgba(44, 187, 99, .25) 0 2px 4px, rgba(44, 187, 99, .25) 0 4px 8px, rgba(44, 187, 99, .25) 0 8px 16px, rgba(44, 187, 99, .25) 0 16px 32px;\n} */\n\n.homeDiv {\n  width: 100%;\n  margin: auto;\n  /* background-color: #151e3d; */\n  /* background-image: url(\"../images/bg.png\"); */\n\n}\n\n.HomeLeftDiv {\n  width: 80%;\n  margin: auto;\n  display: inline-block;\n  height: 100%;\n  padding: 2%;\n  /* background-image: url(\"../images/bg.png\"); */\n  background-color: white\n}\n\n.HomeRightDiv {\n  display: inline-block;\n  height: 100%;\n  width: 50%;\n  background-color: #c2fbd7;\n  height: 100vh;\n  position: fixed;\n  right: 0%;\n  top: 0;\n  z-index: -1;\n}\n\n/* .formDetails{\n    box-shadow: rgba(71, 169, 109, 0.25) 0px 50px 100px -20px, rgba(28, 218, 148, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n    height: 100%;\n    padding: 2%; */\n/* background-color: white; */\n/* background-color: #f6f6f6; */\n/* margin: auto;\n    margin-left: 2%;\n  } */\n.formTitle {\n  text-align: center;\n  color: #174f5d;\n  color: #35b276;\n  color: #151e3d;\n  color: #174f5d;\n  font-weight: 600;\n  margin-top: 3%;\n  margin-bottom:2% ;\n  font-family: 'Open Sans', sans-serif;\n\n}\n\n.formSubText {\n  color: #808080;\n  text-align: center;\n  width: 76%;\n  margin: auto;\n}\n\n.hrLine {\n  color: #35b276;\n  height: 4px;\n  background-color: #35b276;\n  width: 80%;\n  margin: auto;\n  margin-top: 3%;\n  margin-bottom: 10%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
